module.exports = __webpack_public_path__ + "img/slide1.6028cbbf.png";